module.exports = __webpack_public_path__ + "img/illus_33.2cb57207.png";